import {createSlice} from "@reduxjs/toolkit";
import currentURLParamMaintainer from "src/helper/currentURLParamMaintainer";

const dynamic_field_activated_handler = new currentURLParamMaintainer({}, 'bom_dfa');

const initialState = {
    BomDetail: {
        ExactMatchPage: {
            dynamic_field_activated: dynamic_field_activated_handler.getSingleFromURL()
        },
        ExactMatchPageBeforeApply: {
            dynamic_field_activated: dynamic_field_activated_handler.getSingleFromURL()
        },
    }
};


const slice = createSlice({
        name: "BOM__BOMFieldActivated",
        initialState: initialState,
        /*
        Ref for above
        This is to know what can be set for
        programing flow in entire module usage
         BomDetail: {
            ExactMatchPage: {
                dynamic_field_activated: [bomID]:{
                    column1: {
                            fileColumnName: 'Manufacturer Partnumber or Avnet Partnumber',
                            bomColumnName: 'manufacturer_part_number',
                            columnName: 'column1'
                     },
                }
            }
        }*/
        reducers: {
            load_all_dynamic_field_activated: {
                reducer: (state, action) => {
                    if (state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] === undefined) {
                        state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] = {};
                    }
                    if (state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] !== undefined) {
                        state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] = action.payload.bomColumnMapping;
                    }
                },
            },
            remove_all_dynamic_field_activated: {
                reducer: (state, action) => {
                    if (state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] !== undefined
                    ) {
                        delete state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId];
                    }
                },
            },
            set_params_to_current_url_for_dynamic_field_activated: {
                reducer: (state, action) => {
                    state.BomDetail.ExactMatchPage.dynamic_field_activated = state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated;
                    dynamic_field_activated_handler.setAllToURL(state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated);
                },
            },
            toggle_single_dynamic_field_activated: {
                reducer: (state, action) => {
                    if (state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] === undefined) {
                        state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] = {};
                    }
                    if (state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId] !== undefined &&
                        state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId][action.payload.columnName] !== undefined
                    ) {
                        delete state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId][action.payload.columnName];
                    } else {
                        state.BomDetail.ExactMatchPageBeforeApply.dynamic_field_activated[action.payload.bomId][action.payload.columnName] = action.payload;
                    }
                },
            },
        }
    })
;

export let {toggle_single_dynamic_field_activated, load_all_dynamic_field_activated, remove_all_dynamic_field_activated, set_params_to_current_url_for_dynamic_field_activated} = slice.actions;

export default slice.reducer;
